import { render, staticRenderFns } from "./AdminProgressReport.vue?vue&type=template&id=145edb32&scoped=true"
import script from "./AdminProgressReport.vue?vue&type=script&lang=js"
export * from "./AdminProgressReport.vue?vue&type=script&lang=js"
import style0 from "./AdminProgressReport.vue?vue&type=style&index=0&id=145edb32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145edb32",
  null
  
)

export default component.exports